import React from 'react'


interface AsoleacionVideo {
    currentVideo: any,
    currentVideoReversed: any
}

interface Props{
    isAsoleacionActive: boolean,
    isReversed: boolean,
    currentVideoSelected: string,
    currentVideoSelectedReversed: string,
    asoleacionAutoplay: boolean,
    handleGetCurrentVideoDuration: any,
    handleUpdateBar: any
}

interface State{}

class AsoleacionVideo extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }

        this.currentVideo = React.createRef()
        this.currentVideoReversed = React.createRef()
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isAsoleacionActive ? "asoleacion-video-container fade-in":"asoleacion-video-container fade-out"}>
                {
                    this.props.isAsoleacionActive ?
                    <video 
                        ref = {this.currentVideo}
                        playsInline 
                        preload='auto' 
                        id="video" 
                        src={this.props.currentVideoSelected}
                        muted={true}
                        loop={false}
                        autoPlay={false}
                        onLoadedMetadata = {() => {this.props.handleGetCurrentVideoDuration()}}
                        onTimeUpdate = {() => {this.props.handleUpdateBar()}}
                    >
                        <source src={this.props.currentVideoSelected} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>
                    </video>:null
                }
                {
                    this.props.isAsoleacionActive && this.props.isReversed ?
                    <video 
                        ref = {this.currentVideoReversed}
                        playsInline 
                        preload='auto' 
                        id="video" 
                        src={this.props.currentVideoSelectedReversed}
                        muted={true}
                        loop={false}
                        autoPlay={this.props.asoleacionAutoplay}
                        onLoadedMetadata = {() => {this.props.handleGetCurrentVideoDuration()}}
                        onTimeUpdate = {() => {this.props.handleUpdateBar()}}
                    />:null
                }
            </div>
        )
    }
}

export default AsoleacionVideo